import styled from "styled-components";
import { Variables } from "../../../styles/variables";

export const Container = styled.div`
.register_profile_image{
    margin-top: 15px;

    .btn {
        background: ${Variables.gray};
        color: #FFF !important;
        padding: 8px 20px;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        transition: background .15s ease-in-out;

        span {
            color: #FFF;
        }

        &:hover {
            background: #66788a;
        }

        svg,
        .download-icon {
            flex-shrink: 0;
            width: 16px;
            height: 16px;
            color: #FFF !important;
            stroke: #FFF !important;
            display: inline-block;
            vertical-align: middle;
        }
    }
}

.previewProfilePic {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 15px;

    .trash {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        border: 0;
        background: transparent;
        color: ${Variables.danger};
        padding: 4px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .pdf-preview {
        width: 86px;
        height: 86px;
        border-radius: 12px;
        background: #EEF2F6;
        color: #516274;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        &.has-file {
            background: #FFE8E6;
            color: ${Variables.danger};
        }
    }

    .text {
        margin-left: 24px;
        margin-right: 24px;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.4px;
        color: #49454F;
        word-break: break-all;
    }
}
`
